import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PortalAuthService {
  constructor() {}
  setRedirectUri() {}
  public get isAuthenticated(): boolean {
    return true;
  }
}
